"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeywordTagGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/tag/tag-group");
require("@/components/common/tag/semantics/accent-tag");
require("@/components/common/tag/semantics/keyword-tag");
let KeywordTagGroup = class KeywordTagGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.keywords = [];
    }
    render() {
        if (!this.keywords.length)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-tag-group>${this.renderHeading()} ${this.renderKeywords()}</mm-tag-group>
    `;
    }
    renderHeading() {
        if (!this.heading)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-accent-tag>${this.heading}</mm-accent-tag>
    `;
    }
    renderKeywords() {
        return this.keywords.map(keyword => this.renderKeyword(keyword));
    }
    renderKeyword(keyword) {
        return (0, lit_1.html) `
      <mm-keyword-tag>${keyword}</mm-keyword-tag>
    `;
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String })
], KeywordTagGroup.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], KeywordTagGroup.prototype, "keywords", void 0);
KeywordTagGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-keyword-tag-group')
], KeywordTagGroup);
exports.KeywordTagGroup = KeywordTagGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5d29yZC10YWctZ3JvdXAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJrZXl3b3JkLXRhZy1ncm91cC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBK0M7QUFDL0MscURBQTJEO0FBRTNELDZDQUEwQztBQUMxQyx3REFBcUQ7QUFDckQseURBQXNEO0FBRy9DLElBQU0sZUFBZSxHQUFyQixNQUFNLGVBQWdCLFNBQVEsZ0JBQVU7SUFBeEM7O1FBQ3VCLFlBQU8sR0FBRyxFQUFFLENBQUE7UUFDUixhQUFRLEdBQWEsRUFBRSxDQUFBO0lBMEJ6RCxDQUFDO0lBeEJDLE1BQU07UUFDSixJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxNQUFNO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFDekMsT0FBTyxJQUFBLFVBQUksRUFBQTtzQkFDTyxJQUFJLENBQUMsYUFBYSxFQUFFLElBQUksSUFBSSxDQUFDLGNBQWMsRUFBRTtLQUM5RCxDQUFBO0lBQ0gsQ0FBQztJQUVPLGFBQWE7UUFDbkIsSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFakMsT0FBTyxJQUFBLFVBQUksRUFBQTt1QkFDUSxJQUFJLENBQUMsT0FBTztLQUM5QixDQUFBO0lBQ0gsQ0FBQztJQUVPLGNBQWM7UUFDcEIsT0FBTyxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQTtJQUNsRSxDQUFDO0lBRU8sYUFBYSxDQUFDLE9BQWU7UUFDbkMsT0FBTyxJQUFBLFVBQUksRUFBQTt3QkFDUyxPQUFPO0tBQzFCLENBQUE7SUFDSCxDQUFDO0NBQ0YsQ0FBQTtBQTNCNkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2dEQUFhO0FBQ1I7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDO2lEQUF3QjtBQUY1QyxlQUFlO0lBRDNCLElBQUEsNkJBQWEsRUFBQyxzQkFBc0IsQ0FBQztHQUN6QixlQUFlLENBNEIzQjtBQTVCWSwwQ0FBZSJ9